import { calculateInternalUsageCosts } from "./internalUsageCost";

const dayKey = (date) => [
  date.getFullYear(),
  String(date.getMonth() + 1).padStart(2, "0"),
  String(date.getDate()).padStart(2, "0"),
].join("-");

// Attribute each run's calculated internal cost to its recorded day.
export const buildTenantCostTimeline = (runs, fromDate, toDate) => {
  const start = new Date(fromDate);
  const end = new Date(toDate);
  if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime()) || start > end) {
    return { days: [], tenants: [] };
  }
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  const days = [];
  for (const date = new Date(start); date <= end; date.setDate(date.getDate() + 1)) {
    days.push(dayKey(date));
  }
  const dayIndexes = new Map(days.map((day, index) => [day, index]));
  const tenants = new Map();

  runs.forEach((run) => {
    if (run.errorMessage || !run.usage) return;
    const cost = calculateInternalUsageCosts(run.usage).totalCost;
    const date = new Date(run.timestamp);
    if (!Number.isFinite(cost) || !Number.isFinite(date.getTime())) return;
    const index = dayIndexes.get(dayKey(date));
    if (index === undefined) return;

    const id = run.tenantId || "";
    if (!tenants.has(id)) {
      tenants.set(id, {
        id,
        name: run.tenantName || id || "Unknown tenant",
        totalCost: 0,
        dailyCosts: days.map(() => 0),
      });
    }
    const tenant = tenants.get(id);
    tenant.totalCost += cost;
    tenant.dailyCosts[index] += cost;
  });

  return {
    days,
    tenants: [...tenants.values()].sort((a, b) =>
      b.totalCost - a.totalCost || a.name.localeCompare(b.name) || a.id.localeCompare(b.id)),
  };
};
